import VendorTypeForm from "./VendorTypeForm";
import { KListTile, KSelect } from "kinnect-general";
import { FacilityMaintenanceVendorType } from "kinnect-models";
import { VDialog, VIcon } from "vuetify/lib";
import { sortByKey } from "kinnect-helpers";

export default {
	name: "VendorTypeField",

	extends: KSelect,

	props: {
		itemText: {
			default: "name",
			type: String
		},
		itemValue: {
			default: "id",
			type: String
		},
		prependIcon: {
			default: "view_list",
			type: String
		},
		showAddButton: Boolean
	},

	data: () => ( {
		dialogOpen: false
	} ),

	computed: {
		sortedItems() {
			return sortByKey( this.items, this.itemText );
		}
	},

	methods: {
		createItem( { data: item } ) {
			this.$emit( "create", new FacilityMaintenanceVendorType( item ) );
		}
	},

	render() {
		return <KSelect
			attrs={{
				...this.$props,
				items: this.sortedItems
			}}
			on={{ ...this.$listeners }}
			scopedSlots={{ ...this.$scopedSlots }}
		>
			{this.showAddButton && <VDialog
				class="white"
				persistent
				scopedSlots={{ activator: ( { on } ) => <VIcon on={on}>add_circle</VIcon> }}
				slot="append-outer"
				vModel={this.dialogOpen}
				width="500"
			>
				{this.dialogOpen && <VendorTypeForm
					formTitle={"Add a Vendor Category"}
					onClose={() => this.dialogOpen = false}
					onSuccess={this.createItem}
				></VendorTypeForm>}
			</VDialog>}

			<KListTile text="No vendor categories to display" slot="no-data"></KListTile>
		</KSelect>;
	}
};
